import { Injectable } from '@angular/core';
import { FirmwareDefaultParams as DefaultParams } from '@app/models/firmware-default-params.class';
import { Firmware, FirmwareCreate } from '@app/models/firmware.interface';
import { FirmwareService } from '@lib/core';
import { Observable, map, mergeMap } from 'rxjs';
import { AuthService } from '../auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class FirmwareHelperService {
  headers;

  constructor(
    private service: FirmwareService,
    private authService: AuthService,
    private http: HttpClient,
  ) {
    let headers = new HttpHeaders();
    this.headers = headers.set('Authorization', authService.getAccessToken() ?? '');
  }

  getAll(): Observable<Firmware[]> {
    let params = new DefaultParams();
    return this.service.firmwareGet(params)
      .pipe(map(x => <Firmware[]>x));
  }
  getById(id: number): Observable<Firmware> {
    let params = <any>new DefaultParams();
    params.id = 'eq.' + id;
    return this.service.firmwareGet(params)
      .pipe(map(x => <Firmware>x[0]));
  }
  upload(name: string, firmware_version: string, firmware: Blob) {
    let form = new FormData;
    form.append('name', name);
    form.append('firmware_version', firmware_version);
    form.append('firmware', firmware);

    return this.http.post<number>(environment.utilityUrl + '/firmware/upload',
      form,
      { headers: this.headers }
    );
  }
  create(input: FirmwareCreate) {
    return this.service.firmwarePost({
      firmware: <any>input,
      prefer: "return=representation"
    }, 'response')
    .pipe(map(response => response.body[0]))
    .pipe(map(body => {
      //console.log(body)
      return (<Firmware>body).id;
    }));
  }
  update(id: number, input: FirmwareCreate) {
    return this.service.firmwarePatch({
      id: 'eq.'+id,
      firmware: <any>input
    }, 'response')
    .pipe(map(response => response.ok));
  }
}
